"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTag = exports.TextVariant = void 0;
var TextVariant;
(function (TextVariant) {
  TextVariant["LARGE_TITLE"] = "largeTitle";
  TextVariant["TITLE_1"] = "title1";
  TextVariant["TITLE_2"] = "title2";
  TextVariant["TITLE_3"] = "title3";
  TextVariant["BODY"] = "body";
  TextVariant["FOOTNOTE"] = "footnote";
  TextVariant["OVERLINE"] = "overline";
  TextVariant["HEADLINE"] = "headline";
  TextVariant["SUBHEADLINE"] = "subheadline";
  TextVariant["CAPTION"] = "caption";
  TextVariant["CAPTION_XS"] = "captionXs";
  TextVariant["BUTTON"] = "button";
  TextVariant["BUTTON_LARGE"] = "button-large";
})(TextVariant || (exports.TextVariant = TextVariant = {}));
var TextTag;
(function (TextTag) {
  TextTag["DIV"] = "div";
  TextTag["SPAN"] = "span";
  TextTag["P"] = "p";
  TextTag["B"] = "b";
  TextTag["STRONG"] = "strong";
  TextTag["H1"] = "h1";
  TextTag["H2"] = "h2";
  TextTag["H3"] = "h3";
  TextTag["H4"] = "h4";
  TextTag["H5"] = "h5";
  TextTag["H6"] = "h6";
})(TextTag || (exports.TextTag = TextTag = {}));